var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import { formatTIN, TIN_STRICT_PATTERN, TIN_HYPHEN_PATTERN, } from '@ally/aos-utils';
import { Box, FormText } from '@ally/metronome-ui';
import { useRegisterError } from '../utils';
const TIN_LENGTH_WITH_HYPHENS = 10;
export const defaultValidate = (value, required = false) => {
    if (required && !value) {
        return 'Enter a Tax ID number to continue.';
    }
    if (value && !TIN_STRICT_PATTERN.test(value)) {
        return 'Enter a valid 9-digit Tax ID number.';
    }
    return undefined;
};
const mask = (val = '') => {
    return val && val.length === TIN_LENGTH_WITH_HYPHENS
        ? `••-•••${val.slice(-4)}`
        : val;
};
const TIN = (_a) => {
    var { className, name, label = 'Tax Identification Number', id, onBlur, onFocus, onChange, required = false, validate, value } = _a, props = __rest(_a, ["className", "name", "label", "id", "onBlur", "onFocus", "onChange", "required", "validate", "value"]);
    const combinedValidate = (val) => {
        const errorMessage = defaultValidate(val, required);
        if (!errorMessage && validate) {
            return validate(val);
        }
        return errorMessage;
    };
    const [field, meta, helpers] = useField(Object.assign(Object.assign({}, props), { name, validate: combinedValidate }));
    const { refValue } = useRegisterError(meta.error);
    const getInitialDisplayValue = () => {
        if (value) {
            return (refValue === null || refValue === void 0 ? void 0 : refValue.current) === document.activeElement
                ? value
                : mask(value);
        }
        return '';
    };
    const [displayValue, setDisplayValue] = useState(getInitialDisplayValue);
    const combinedOnBlur = (e) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        helpers.setValue(e.target.value);
        field.onBlur(e);
        const maskedValue = mask(e.target.value);
        setDisplayValue(maskedValue);
    };
    const combinedOnFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setDisplayValue(field.value);
    };
    const combinedOnChange = (e) => {
        const isFocused = (refValue === null || refValue === void 0 ? void 0 : refValue.current) === document.activeElement;
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        e.target.value = formatTIN(e.target.value);
        setDisplayValue(isFocused ? e.target.value : mask(e.target.value));
        helpers.setValue(e.target.value);
        field.onChange(e);
    };
    const errorMessage = meta.touched ? meta.error : '';
    useEffect(() => {
        setDisplayValue(prevDisplay => formatTIN(prevDisplay) === formatTIN(field.value)
            ? prevDisplay
            : mask(formatTIN(field.value)));
    }, [field.value]);
    return (React.createElement(Box, { className: className },
        React.createElement(FormText, Object.assign({ variant: "input", labelContent: label, autoComplete: "off", isPrivate: true, errorNotification: { message: errorMessage }, id: id || name, inputType: "text", name: name, onBlur: combinedOnBlur, onChange: combinedOnChange, onFocus: combinedOnFocus, value: displayValue, pattern: `${TIN_HYPHEN_PATTERN}`, ref: refValue, required: required }, props))));
};
export default TIN;
//# sourceMappingURL=TIN.js.map